const sorters = {
  latest: (a, b) => new Date(b.published) - new Date(a.published),
  popular: (a, b) => (b.plays || 0) - (a.plays || 0),
  name: (a, b) => a.title.localeCompare(b.title),
};

export default class GameStore {
  constructor(games = [], options = {}) {
    this.games = games;
    this.state = {
      category: options.category || 'all',
      sort: options.sort || 'latest',
      search: options.search || '',
      page: options.page || 1,
      perPage: options.perPage || 24,
    };
    this.listeners = new Set();
  }

  subscribe(fn) {
    this.listeners.add(fn);
    fn(this.getSnapshot());
    return () => this.listeners.delete(fn);
  }

  setState(patch) {
    this.state = { ...this.state, ...patch };
    this.emit();
  }

  resetFilters() {
    this.setState({ category: 'all', search: '', page: 1 });
  }

  setCategory(category) {
    this.setState({ category, page: 1 });
  }

  setSearch(search) {
    this.setState({ search, page: 1 });
  }

  setSort(sort) {
    this.setState({ sort, page: 1 });
  }

  loadMore() {
    const totalPages = Math.ceil(this.getFilteredGames().length / this.state.perPage);
    if (this.state.page < totalPages) {
      this.setState({ page: this.state.page + 1 });
    }
  }

  getFilteredGames() {
    const { category, search } = this.state;
    let filtered = [...this.games];

    if (category && category !== 'all') {
      filtered = filtered.filter(game => game.categories.includes(category));
    }

    if (search) {
      const token = search.toLowerCase();
      filtered = filtered.filter(game => {
        const haystack = [game.title, ...(game.tags || []), ...(game.categories || [])]
          .join(' ')
          .toLowerCase();
        return haystack.includes(token);
      });
    }

    return filtered;
  }

  getSortedGames() {
    const { sort } = this.state;
    const sorter = sorters[sort] || sorters.latest;
    return this.getFilteredGames().sort(sorter);
  }

  getVisibleGames() {
    const sorted = this.getSortedGames();
    const count = this.state.page * this.state.perPage;
    return sorted.slice(0, count);
  }

  hasMore() {
    const sorted = this.getSortedGames();
    return this.state.page * this.state.perPage < sorted.length;
  }

  getSnapshot() {
    return {
      state: { ...this.state },
      total: this.getFilteredGames().length,
      visible: this.getVisibleGames(),
      hasMore: this.hasMore(),
    };
  }

  emit() {
    const snapshot = this.getSnapshot();
    this.listeners.forEach(listener => listener(snapshot));
  }
}
